<template>
    <FormPage
        :title="$route.meta.header"
        routeBack="/account-request"
    >
        <ul class="nav-container" slot="nav">
            <li class="nav-item">
                {{ $route.meta.tab }}
            </li>
        </ul>

        <AccountForm
            class="account-form"
            storeModule="accountRequest"
            slot="content"
        />
    </FormPage>
</template>

<script>
import FormPage from '@/components/layouts/FormPage'
import AccountForm from '@/components/layouts/AccountForm'

import * as accountRequest from '@/store/account-request/app.js'
import * as accountOverview from '@/store/account-overview/app.js'
import * as accountForm from '@/store/account-form/app.js'

import { mapFields } from 'vuex-map-fields'

export default {
    props: ['id'],

    async beforeRouteLeave(to, from, next) {
        if (this.$route.name.indexOf('create') === -1 || this.hasUpdatedList) {
            if (this.hasUpdatedList) this.hasUpdatedList = false
            next()
            return
        }

        await this.$store.commit('accountRequest/hasFormChanged')

        if (this.hasFormChanged && !this.isAccountFormEmpty()) {
            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'All your inputs will be gone!',
                action: () => {
                    this.$store.commit('accountRequest/clearForm')
                    next()
                }
            })

            return
        }

        next();
    },

    async beforeCreate () {
        if (!this.$store._modulesNamespaceMap['accountRequest/']) {
			this.$store.registerModule('accountRequest', accountRequest.default)
        }

        if (!this.$store._modulesNamespaceMap['accountOverview/']) {
			this.$store.registerModule('accountOverview', accountOverview.default)
        }
        
        if (!this.$store._modulesNamespaceMap['accountForm/']) {
			this.$store.registerModule('accountForm', accountForm.default)
		}
    },

    created () {
        if (this.$route.name !== 'approve-account-request') return

        if (this.id) {
            this.getAccountDetails()
        } else {
            this.$router.push('/account-request')
        }
    },

    computed: {
        ...mapFields('accountForm', [
            'accountForm',
            'isUpdateAccount',
            'hasFormChanged',
            'hasUpdatedList',
            'formLoading'
        ]),

        ...mapFields('accountRequest', {
            accountFormLoading: 'formLoading'
        }),

        ...mapFields('accountOverview', [
            'accountDetails'
        ]),

        ...mapFields('global', [
            'sessionTypeList',
            'countryPartnerList'
        ]),
    },

    watch: {
        accountFormLoading (val) {
            this.formLoading = val
        }
    },

    methods: {
        async getAccountDetails () {
            await this.$store.dispatch(
                'accountOverview/getAccountDetails',
                `/cms/client/view?id=${this.id}`
            )

            this.setAccountForm()
        },

        setAccountForm () {
            const {
                id, company_name, first_name, last_name,
                country, zone_name, zip_code, country_code,
                contact_no, phone_number, email, company_email, subscription_start, subscription_end,
                user_allocation, price, company_type,
                partner, session_type, prebuilt_default, bldg_apt_name, street, city
            } = this.accountDetails

            this.accountForm = {
                id,
                company_name,
                first_name,
                last_name,
                country: {
                    name: country
                },
                zone_name: {
                    zone_name: zone_name
                },
                zip_code: zip_code || '',
                
                country_code: { int_dialing: country_code },
                contact_no: contact_no || '',
                phone_number: phone_number || '',
                email,
                company_email,
                subscription_start: subscription_start || '',
                subscription_end: subscription_end || '',
                user_allocation: user_allocation || '',
                categories: session_type ? session_type.split(',').map(x=>this.sessionTypeList.find(y=>y.type === x.toLowerCase())) : [],
                prebuilt_default: prebuilt_default ? [this.sessionTypeList.find(y=>y.type === prebuilt_default.toLowerCase())] : [],
                price: price || '',
                company_type: {name: company_type},
                partnerCountry: partner.id ? this.countryPartnerList.filter(x=>x.country === partner.country)[0] : {},
                partner: partner || {},
                account_status: 0,
                bldg_apt_name,
                street,
                city
            }

            this.isUpdateAccount = true

            if (country) this.getCountryZone(country)
            if (partner.id) this.getPartnerList(partner.country)
        },

        getPartnerList (countryName) {
            this.$store.dispatch('global/getPartnerList', countryName)
        },

        getCountryZone (countryName) {
            this.$store.dispatch('global/getCountryZone', countryName)
        },

        isAccountFormEmpty () {
            const accountForm = JSON.parse(JSON.stringify(this.accountForm))
            delete accountForm.account_status

            return Object.keys(accountForm).every(property => {
                const formProperty = accountForm[property]

                return formProperty === '' || (
                    formProperty.constructor === Object
                    && !Object.keys(formProperty).length
                )
            })
        }
    },

    components: {
        FormPage,
        AccountForm
    },
}
</script>

<style lang="scss" scoped>
.nav-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    
    .nav-item {
        padding: 10px 0;
        border-bottom: 1px solid #2DC4B6;
        color: #2DC4B6;
        font-size: 14px;
    }
}

.account-form {
    padding-top: 15px;
}
</style>